import React, { createContext, useContext, useEffect, useMemo } from "react";
import { useAuth } from "../../../components/contexts/AuthContext";
import { createMediaAnalysisStore } from "../viewmodels/mediaAnalysisStore";

const MediaAnalysisContext = createContext(null);
export const useMediaAnalysisStore = () => useContext(MediaAnalysisContext);
export function MediaAnalysisProvider({ children }) {
  const { authState } = useAuth();
  const actor = authState?.isAuthenticated ? authState.id : null;
  const { store } = useMemo(() => ({ actor, store: createMediaAnalysisStore() }), [actor]);
  useEffect(() => () => store.clear(), [store]);
  return <MediaAnalysisContext.Provider value={actor == null ? null : store}>{children}</MediaAnalysisContext.Provider>;
}
